<uc-course-search-load-more-btn
	class="block mt-8"
	[isLoading]="isLoading()"
	[page]="page()"
	[searchTerm]="searchTerm()"
	(loadMore)="loadMore.emit($event)"
/>
<!-- TODO: handle the new URL structure -->
<uc-seo-pagination
	ngSkipHydration
	link=""
	[hasMorePages]="hasMorePages()"
	[queryParams]="{}"
/>
